import { useAuth } from './AuthContext';
import Login from '../pages/LoginPage';
import { Navigate, useLocation } from 'react-router-dom';

function PrivateRoute({ children }) {
    const auth = useAuth();
    const location = useLocation();
    //const navigate = useNavigate();
    if (auth.isLoggedIn) {
        // If the user is authenticated, render the children components
        return children;
    }
    // If the user is not authenticated, return the login component
    //
    else {
        return <Login />;
    }
}

export default PrivateRoute;